import { useState, useEffect, createContext } from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";

const AssessmentQuestionContext = createContext({
  questions: {},
  sections: [],
  addSections: (addSections) => {},
  addQuestions: (addQuestions) => {},
  updateAnswer: (updateAnswer) => {},
  updateTextAnswer: (updateTextAnswer) => {},
});

export function AssessmentQuestionContextProvider(props) {

  const location = useLocation();

  const [questions, setQuestions]     = useState([]);
  const [sections, setSections] = useState([]);

  // console.log(location.pathname.split("/").includes("review"));
  useEffect(() => {
    if(location.pathname.split("/").includes("review")) {
      let localStoredQuestions = JSON.parse(sessionStorage.getItem("assessmentAnswers"));
      if(localStoredQuestions?.length) {
        setQuestions(localStoredQuestions);
      }
    }
  }, [location]);

  function addQuestionsHandler(data) {
    setQuestions(data);
  }

  function addSectionsHandler(data) {
    setSections(data);
  }

  function updateAnswerHandler(questionId, answer) {
    let question      = questions.find(function(obj) { return obj.id == questionId; });
    question.answer   = answer;
    let localQuestions  = [];
    questions.forEach(q => localQuestions.push(q));
    sessionStorage.setItem('assessmentAnswers', JSON.stringify(localQuestions));
  }

  function updateTextAnswerHandler(questionId, answer) {
    let question        = questions.find(function(obj) { return obj.id == questionId; });
    question.answerTxt  = answer;
    let localQuestions  = [];
    questions.forEach(q => localQuestions.push(q));
    sessionStorage.setItem('assessmentAnswers', JSON.stringify(localQuestions));
  }

  const context = {
    questions: questions,
    addQuestions: addQuestionsHandler,
    updateAnswer: updateAnswerHandler,
    updateTextAnswer: updateTextAnswerHandler,
    sections,
    addSectionsHandler
  };

  return <AssessmentQuestionContext.Provider value={context}>
    {props.children}
  </AssessmentQuestionContext.Provider>
}

export default AssessmentQuestionContext;
